import { createContext, ReactNode } from "react";

import { useGetCompanyCategoriesQuery } from "api/graphql/queries/company-category/hooks";

import { TCompanyCategoriesContext } from "./types";

export const CompanyCategoriesContext = createContext(
  {} as TCompanyCategoriesContext
);

export function CompanyCategoriesContextProvider({
  children,
}: {
  children: ReactNode;
}) {
  const { data: companyCategoriesData, loading: loadingCompanyCategoriesData } =
    useGetCompanyCategoriesQuery();

  const companyCategories =
    companyCategoriesData?.getCompanyCategories.edges.map((edge) => edge.node);

  return (
    <CompanyCategoriesContext.Provider
      value={{
        companyCategories,
        loadingCompanyCategoriesData,
      }}
    >
      {children}
    </CompanyCategoriesContext.Provider>
  );
}
